import { useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	icon: LucideIcon;
	label: string;
	value: string;
	wrapValue?: boolean;
	isLast?: boolean;
};

export const ProfileAccountRow: FC<Props> = ({
	icon: Icon,
	label,
	value,
	wrapValue,
	isLast,
}) => {
	const theme = useTheme();

	return (
		<ListRow
			title={value}
			subtitle={label}
			labelFirst
			wrapTitle={wrapValue}
			icon={<Icon size={theme.iconSize.sm} color={theme.palette.grey[500]} />}
			iconBg={theme.palette.grey[100]}
			showChevron={false}
			isLast={isLast}
		/>
	);
};
